export { default } from './Soap';
